import { AuthenticatedJsonExport } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type { GetModelResponse } from '@eggplant/types'

interface Props {
  onSuccess: (data: object) => GetModelResponse
  fileName: string
  id: string
}

const ExportModelerModelRequest = ({
  onSuccess,
  fileName,
  id
}: Props) => {
  const url = `${MODELER_SERVICE}/models/${id}/latest_version/export`

  return (
    <AuthenticatedJsonExport
      fileName={fileName}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default ExportModelerModelRequest
